import React, { Component } from 'react';
import { ReactComponent as Back } from '../../../assets/svg/chevron-left.svg';
import { ReactComponent as Down } from '../../../assets/svg/down-arrow-search.svg';
import { ReactComponent as DownIcon } from '../../../assets/svg/chevron-down.svg';
import { withRouter } from '../../../services/withRoute';
import LoadingBar from '../../components/global/loadingBar';
import { gql } from '@apollo/client';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import ShootsListTableRow from '../../components/shootListTableRow';
import Modal from '../../components/modals';
import CreateShoot from '../../components/modals/projects/createShoot';
import jwt_decode from 'jwt-decode';
import Tree from '../../components/tree';
import moment from 'moment';
import _ from 'lodash';
import RecordHDDContents from '../../components/modals/projects/recordHDDContents';

const projectDetails = gql`
	query VendorsProject($projectId: ID!, $workspaceId: String!) {
		vendorsProject(projectId: $projectId, workspaceId: $workspaceId) {
			events {
				id
				name

				venue
				date
				time
				reportingTime
				durationInHrs

				parentEvent_id
				parentEventName
				city

				memoryCards {
					status
					isReceived
					__typename
				}
				equipments {
					isReceived
					status
					__typename
				}
				additionalServices {
					type
					_id
				}
				crew {
					count
					role
					managerIds
					subRole
					userIds
					__typename
				}
				crewNew {
					userId
					roles {
						role
						subRole
					}
					isManager
					isCustomUser
				}
			}
			hardDrives {
				_id
				qrCode
				category
				status
				size
				contents {
					_id
					files {
						_id
						fileType
						originalFileName
						s3KeyOriginal
						originalFileSizeInMb
					}
					createdBy {
						id
					}
					backupPath
					numberOfFiles
					size
					isVerified
				}
				createdBy
				manufacturer
				manufacturerId
			}
			title
			id
		}
		vendorUsers {
			isShooter
			lastName
			firstName
			isEmailVerified
			firstName
			id
			displayName
			isSuspended
			phoneNumber
			accessibleTenants {
				tenant_id
				workspaceId
				role
				walletBalance
			}
		}
	}
`;
const getVendorEventsList = gql`
	query VendorEventsList($filters: VendorEventsListFiltersInput, $vendorId: String!) {
		vendorEventsList(filters: $filters) {
			data {
				id
				tenantId
				projectId
				name
				projectSlNo
				slNo
				category
				crew {
					count
					role
					managerIds
					subRole
					userIds
					__typename
				}
				crewNew {
					userId
					roles {
						role
						subRole
					}
					isManager
					isCustomUser
				}
				city
				venue
				date
				outStation
				time
				flagLabel
				reportingTime
				durationInHrs
				dateOverlap
				dateTimeOverlap
				parentEvent_id
				projectTitle
				parentEventName
				childEvents {
					_id
					expenses {
						_id
						amount
						billTo
						billDate
						currency
						__typename
					}
					name
					parentEvent_id
					__typename
				}
				memoryCards {
					status
					isReceived
					__typename
				}
				equipments {
					isReceived
					status
					__typename
				}
				unregisteredEqs {
					_id
					status
					manufacturerId
					isReceived
					createdBy {
						id
						name
					}
					createdAt
					receivedAt
					receivedBy {
						id
						name
					}
					description
					quantity
					receivedQuantity
					id
				}
				additionalServices {
					type
					_id
					__typename
				}
				feedBack {
					_id
					submittedBy
					submittedOn
					files {
						_id
						fileType
						originalFileName
						s3KeyOriginal
						originalFileSizeInMb
					}
				}
				collaborators {
					designations
					isManager
					tenantUserId
				}
				__typename
			}
			totalPages
			totalDocs
			limit
			currentPage
			hasNextPage
			nextPage
			__typename
		}
		vendorInfo(vendorId: $vendorId) {
			id
			businessName
			vendorId
			associatedTenants {
				_id
				workspaceId
				workspaceKey
				__typename
			}
			isSuperHuemn
			__typename
		}
		vendorUsers {
			isShooter
			isSuspended
			lastName
			isEmailVerified
			firstName
			id
			displayName
			phoneNumber
			accessibleTenants {
				tenant_id
				workspaceId
				role
				walletBalance
			}
		}
	}
`;
const updateShoot = gql`
	mutation UpdateEvent(
		$projectId: ID!
		$eventId: ID!
		$eventInput: EventInput!
		$workspaceId: String!
	) {
		updateEvent(
			projectId: $projectId
			eventId: $eventId
			eventInput: $eventInput
			workspaceId: $workspaceId
		) {
			id
			tenantId
			projectId
			name
			projectSlNo
			slNo
			category
			crew {
				count
				role
				managerIds
				subRole
				userIds
			}
			crewNew {
				userId
				roles {
					role
					subRole
				}
				isManager
				isCustomUser
			}
			city
			venue
			date
			time
			flagLabel
			reportingTime
			durationInHrs
			dateOverlap
			dateTimeOverlap
			parentEvent_id
			projectTitle
			parentEventName
			childEvents {
				_id
				expenses {
					_id
					amount
					billTo
					billDate
					currency
				}
				name
				parentEvent_id
			}
			memoryCards {
				status
				isReceived
			}
			equipments {
				isReceived
				status
			}
			additionalServices {
				type
				_id
			}

			feedBack {
				_id
				submittedBy
				submittedOn
				files {
					_id
					fileType
					originalFileName
					s3KeyOriginal
					originalFileSizeInMb
				}
			}
			unregisteredEqs {
				_id
				status
				manufacturerId
				isReceived
				createdBy {
					id
					name
				}
				createdAt
				receivedAt
				receivedBy {
					id
					name
				}
				description
				quantity
				receivedQuantity
				id
			}
		}
	}
`;
class ProjectDetails extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			isLoading: true,
			shootList: [],
			projectDetails: {},
			limit: 100,
			page: 1,
			showCreateShootModal: false,
			activeShootID: null,
			activePath: null,
			tenantUserId: null,
			showHddContentModal: false,
			columns: [
				// { title: 'FLAG' },
				{ title: 'TIME' },
				{ title: 'CITY/VENUE' },
				{ title: 'SHOOT ID' },
				{ title: 'SHOOT' },
				{ title: 'CP' },
				{ title: 'TP' },
				{ title: 'CV' },
				{ title: 'TV' },
				{ title: 'EQ' },
				{ title: 'MC' },
				{ title: 'ADD SERVICES' },
				{ title: 'FEEDBACK' },
				{ title: 'HEADS' },
			],
			activeHddId: null,
			associatedTenants: [],
			isCrewCopied: false,
			copiedCrew: [],
			showDuplicateCrewWithRoleWarning: false,
			duplicateCrewWithRole: [],
			shootEditType: null,
		};
	}
	componentDidMount = async () => {
		let userToken = localStorage.getItem('usertoken');
		let decoded = jwt_decode(userToken);

		this.setState({
			tenantUserId: decoded.user_id,
		});
		let json = {
			filters: {
				page: this.state.page,
				limit: this.state.limit,
				projectId: this.props.params.projectID,
			},
			vendorId: this.props.params.vendorID,
		};

		await this.getVendorEventsList(getVendorEventsList, json);
		await this.getVendorsProjectDetails(projectDetails, {
			projectId: this.props.params.projectID,
			workspaceId: this.props.params.workspaceID,
		});
	};

	shootDetailsUpdated = () => {
		this.setState(
			{
				shootEditType: null,
				shootList: [],
				lengthOfList: 0,
				isLoading: true,
			},
			() => {
				let json = {
					filters: {
						page: this.state.page,
						limit: this.state.limit,
						projectId: this.props.params.projectID,
					},
					vendorId: this.props.params.vendorID,
				};

				this.getVendorEventsList(getVendorEventsList, json);
			},
		);
	};
	pathToTree = (paths) => {
		const tree = {};
		for (let i = 0; i < paths.length; ++i) {
			const path = paths[i].backupPath;
			const items = paths[i].numberOfFiles;
			const sizeInGB = paths[i].size;
			const isVerified = paths[i].isVerified == true ? true : false;

			if (path) {
				let node = tree;

				const parts = path.split(/[\\\/¥₩]+/i);

				for (let j = 0; j < parts.length; ++j) {
					const part = parts[j];
					if (part) {
						node =
							node[part] ??
							(node[part] =
								items && j == parts.length - 1
									? { path, items, sizeInGB, isVerified }
									: {});
					}
				}
			}
		}
		return tree;
	};
	goBack = (e) => {
		this.props.navigate(-1);
	};
	toggleCreateShoot = async (e) => {
		this.setState(
			{
				activeShootID: null,
			},
			() => {
				this.setState({
					showCreateShootModal: true,
				});
			},
		);
	};

	copyCrewFromEvent = (crew) => {
		this.setState({
			copiedCrew: crew,
			isCrewCopied: true,
		});
	};

	pasteCrewToEvent = async (tenantId, projectId, eventId, copyToEventCrew) => {
		let duplicateCrewWithRole = _.filter(this.state.copiedCrew, (crewTemp, inx) => {
			let found = undefined;
			found = _.find(copyToEventCrew, {
				id: crewTemp.id,
				role: crewTemp.role,
				subRole: crewTemp.subRole,
			});
			if (found) {
				return true;
			} else {
				return false;
			}
		});

		if (_.size(duplicateCrewWithRole) > 0) {
			this.setState({
				showDuplicateCrewWithRoleWarning: true,
				duplicateCrewWithRole: duplicateCrewWithRole,
			});
		} else {
			let copyCrew = [];
			_.forEach([...this.state.copiedCrew, ...copyToEventCrew], (crew, index) => {
				let foundIndex = -1;
				foundIndex = _.findIndex(copyCrew, {
					userId: crew.id,
				});
				if (foundIndex !== -1) {
					copyCrew[foundIndex].roles.push({
						role: crew.role,
						subRole: crew.subRole,
					});
					copyCrew[foundIndex].isManager =
						copyCrew[foundIndex].isManager === true ? true : crew.isManager;
				} else {
					copyCrew.push({
						roles: [{ role: crew.role, subRole: crew.subRole }],
						userId: crew.id,
						isManager: crew.isManager,
					});
				}
			});

			let json = {
				projectId,
				eventId,
				eventInput: {
					crewNew: copyCrew,
				},
				workspaceId: _.find(this.state.workspacesFilters, {
					key: tenantId,
				})?.name,
			};

			await this.putShoot(updateShoot, json);

			this.setState({
				isCrewCopied: false,
				copiedCrew: [],
			});
		}
	};

	handleSingleCrewRemove = async (event, index, rolesIndex) => {
		let crewNew = _.cloneDeep(event.crewNew);
		crewNew[index].roles.splice(rolesIndex, 1);
		if (_.size(crewNew[index].roles) === 0) {
			crewNew.splice(index, 1);
		}

		crewNew = _.map(crewNew, (cr, inx) => {
			let newCr = _.omit(cr, ['__typename', 'isCustomUser']);
			newCr.roles = _.map(newCr.roles, (roles, indx) => {
				return _.omit(roles, ['__typename']);
			});
			return newCr;
		});
		let json = {
			projectId: event.projectId,
			eventId: event.id,
			eventInput: {
				crewNew: crewNew,
			},
			workspaceId: _.find(this.state.workspacesFilters, {
				key: event.tenantId,
			})?.name,
		};

		await this.putShoot(updateShoot, json);
	};

	render() {
		let previousDate = null;
		return (
			<>
				{this.state.isLoading ? (
					<div
						style={{
							position: 'relative',
							height: 'calc(100vh - 102px)',
							width: 'calc(100vw - 403px)',
						}}
					>
						<LoadingBar />
					</div>
				) : (
					<div className="assign-receive-container">
						<div
							className="arc-header"
							style={{ position: 'fixed', width: 'calc(100vw - 80px)', zIndex: 10 }}
						>
							<div className="back-btn" onClick={(e) => this.goBack(e)}>
								<Back />
							</div>
							<div className="arch-item">
								<span>Workspace</span>
								<b>{this.props.params.workspaceID}</b>
							</div>
							<div className="next-btn">
								{' '}
								<Back />
							</div>
							<div className="arch-item">
								<span>Project</span>
								<b>{this.state.projectDetails.title}</b>
							</div>
							<div className="next-btn">
								{' '}
								<Back />
							</div>

							<div className="arch-item">
								<span>Shoots</span>
							</div>
							<div className="actn-btn">
								<a onClick={(e) => this.toggleCreateShoot(e)}>+ Create Shoot</a>
							</div>
						</div>
						<div
							className="arc-body projects-table-outer-container"
							style={{ display: 'flex', flexDirection: 'column', top: '64px' }}
						>
							<div className="pd-item">
								<div className="pd-item-header">
									Shoots {`(${_.size(this.state.projectDetails.events)})`}
								</div>
								<div className="pd-item-body">
									<div
										className={'table shoots-table'}
										id={'scrollableDiv-shoots-vendors'}
										style={{
											//height: 'calc(100vh - 138px)',
											overflowY: 'auto',
											top: 0,
											padding: 0,
										}}
									>
										<table className={'shootTable'}>
											<thead>
												<tr>
													{_.map(this.state.columns, (column, key) => {
														return (
															<th
																className={
																	_.has(column, 'className')
																		? column.className
																		: 'all-other-column-fixed'
																}
															>
																<div className="th-header">
																	{_.has(column, 'dummyPad') ? (
																		<span
																			className="dummy-pad"
																			style={{
																				minWidth:
																					_.has(
																						column,
																						'dummyPad',
																					) &&
																					_.has(
																						column,
																						'dummyPadWidth',
																					)
																						? column.dummyPadWidth
																						: '',
																			}}
																		></span>
																	) : (
																		''
																	)}
																	<p className="header-title">
																		{column.title}{' '}
																		{_.has(
																			column,
																			'lineBreakTitle',
																		) ? (
																			<>
																				{' '}
																				<br />{' '}
																				{
																					column.lineBreakTitle
																				}
																			</>
																		) : (
																			''
																		)}
																	</p>
																	{_.has(column, 'sortBy') ? (
																		<span
																			className={
																				'sort-icn' +
																				(this.state[
																					`${column.sortBy}SortType`
																				] == -1
																					? ' sort-visible'
																					: this.state[
																							`${column.sortBy}SortType`
																					  ] == 1
																					? ' sort-visible sort-ascending'
																					: ' sort-hidden')
																			}
																		>
																			<Down />
																		</span>
																	) : (
																		''
																	)}
																</div>
															</th>
														);
													})}
												</tr>
											</thead>

											<tbody>
												{_.map(
													_.orderBy(
														this.state.shootList,
														['date'],
														['asc'],
													),
													(shoot, index) => {
														const currentDate = moment(
															shoot.date,
															'YYYYMMDD',
														).format('DD MMM');
														// Check if the current date is different from the previous date
														const isNewDate =
															currentDate !== previousDate;
														previousDate = currentDate;

														let photoHeads = [];
														let videoHeads = [];

														_.map(shoot.collaborators, (collab) => {
															if (
																_.indexOf(
																	collab.designations,
																	'photographer',
																) >= 0
															) {
																let user = _.filter(
																	this.state.tenantUsersList,
																	{
																		key: collab.tenantUserId,
																	},
																)[0];
																if (_.has(user, 'name'))
																	photoHeads.push(user.name);
															}
															if (
																_.indexOf(
																	collab.designations,
																	'videographer',
																) >= 0
															) {
																let user = _.filter(
																	this.state.tenantUsersList,
																	{
																		key: collab.tenantUserId,
																	},
																)[0];
																if (_.has(user, 'name'))
																	videoHeads.push(user.name);
															}
														});
														return (
															<>
																{isNewDate && (
																	<tr
																		style={{
																			position: 'sticky',
																			top: '30px',
																		}}
																	>
																		{this.state.columns.map(
																			(el, idx) => {
																				return (
																					<td
																						className="emptyCell"
																						style={{
																							textAlign:
																								'center',
																							color: 'white',
																							// position: 'sticky',
																							// top: '0',
																						}}
																					>
																						{idx === 0
																							? shoot.date
																								? moment(
																										shoot.date,
																										'YYYYMMDD',
																								  ).format(
																										'DD MMM',
																								  )
																								: 'TBD'
																							: ''}
																					</td>
																				);
																			},
																		)}
																	</tr>
																)}

																<ShootsListTableRow
																	columns={this.state.columns}
																	key={shoot.id}
																	data={{
																		...shoot,
																	}}
																	associatedTenants={
																		this.state.associatedTenants
																	}
																	handleShootClick={(e) =>
																		this.props.navigate(
																			`/${this.props.params.vendorID}/shoots/${this.props.params.workspaceID}/${this.props.params.projectID}/${shoot.id}`,
																		)
																	}
																	handleSingleCrewRemove={
																		this.handleSingleCrewRemove
																	}
																	onFlagSelected={
																		this.onFlagSelected
																	}
																	handleCrewClick={(type) =>
																		this.setState({
																			activeShootID: shoot.id,
																			showCreateShootModal: true,
																			shootEditType: type,
																		})
																	}
																	handleEquipmentClick={(e) =>
																		console.log(e)
																	}
																	handleMCClick={(e) =>
																		console.log(e)
																	}
																	isProjectShootsList={true}
																	photoHeads={photoHeads}
																	videoHeads={videoHeads}
																	copyCrew={(crew) =>
																		this.copyCrewFromEvent(crew)
																	}
																	pasteCrew={
																		this.pasteCrewToEvent
																	}
																	isCrewCopied={
																		this.state.isCrewCopied
																	}
																/>
															</>
														);
													},
												)}
											</tbody>
										</table>
									</div>
								</div>
							</div>

							<div className="pd-item">
								<div className="pd-item-header">
									Harddrives {`(${_.size(this.state.projectDetails.hardDrives)})`}
								</div>
								<div className="pd-item-body horizontal-scroll-hdds">
									{/**HDD Item */}

									{_.map(this.state.projectDetails.hardDrives, (hdd, key) => {
										return (
											<div className="pd-hdd-item">
												<div className="pdhdditem-header">
													<span className="title">
														{hdd.category === 'secured'
															? 'secure'
															: hdd.category}
													</span>
													<span className="qrCode">({hdd.qrCode})</span>
												</div>
												<div className="pdhdditem-details">
													<div className="pdhdditem-collapse">
														{' '}
														<DownIcon /> Details
													</div>
													<div className="pdhdditemc-item">
														<span className="title">
															Display name:{' '}
														</span>
														<span className="desc">{hdd.qrCode}</span>
													</div>
													<div className="pdhdditemc-item">
														<span className="title">QR Code: </span>
														<span className="desc">{hdd.qrCode}</span>
													</div>
													<div className="pdhdditemc-item">
														<span className="title">Manufaturer: </span>
														<span className="desc">
															{hdd.manufacturer}
														</span>
													</div>
													<div className="pdhdditemc-item">
														<span className="title">
															Manufacturer Id:{' '}
														</span>
														<span className="desc">
															{hdd.manufacturerId}
														</span>
													</div>
													<div className="pdhdditemc-item">
														<span className="title">Size: </span>
														<span className="desc">{hdd.size}TB</span>
													</div>
													<div className="pdhdditemc-item">
														<span className="title">
															Registerd By:{' '}
														</span>
														<span className="desc">
															{
																_.filter(this.state.vendorUsers, {
																	id: hdd.createdBy,
																})[0]?.firstName
															}
														</span>
													</div>
													<div className="pdhdditemc-item">
														<span className="title">Project: </span>
														<span className="desc">
															{this.state.projectDetails.title}
														</span>
													</div>
												</div>
												<div className="pdhdditem-contents">
													<div className="pdhdditem-collapse">
														<DownIcon /> Contents{' '}
														<span
															onClick={(e) =>
																this.setState(
																	{
																		activeHddId: hdd._id,
																	},
																	() => {
																		this.setState({
																			showHddContentModal: true,
																		});
																	},
																)
															}
															style={{
																fontSize: 14,
																marginLeft: 5,
																cursor: 'pointer',
															}}
														>
															+
														</span>
													</div>
													<div className="hdd-tree-view">
														<Tree
															data={
																hdd.contents !== null &&
																_.size(hdd.contents) > 0
																	? this.pathToTree(hdd.contents)
																	: []
															}
															contents={hdd.contents}
															hardDrive={hdd.qrCode}
															hardDriveID={hdd._id}
															createdBy={this.state.tenantUserId}
														/>
													</div>
												</div>
											</div>
										);
									})}
								</div>
							</div>
						</div>

						{this.state.showCreateShootModal === true ? (
							<CreateShoot
								handleClose={() =>
									this.setState({
										showCreateShootModal: false,
										shootEditType: null,
									})
								}
								show={this.state.showCreateShootModal}
								close={() =>
									this.setState(
										{ showCreateShootModal: false, shootEditType: null },
										async () => {
											await this.getVendorsProjectDetails(projectDetails, {
												projectId: this.props.params.projectID,
												workspaceId: this.props.params.workspaceID,
											});
										},
									)
								}
								//data={this.state.eventDetails}
								activeShootID={this.state.activeShootID}
								projectTitle={this.state.projectDetails.title}
								tenantId={null}
								tenantUsersList={this.state.tenantUsersList}
								shootCrewUpdated={(crew) => window.location.reload()}
								shootDetailsUpdated={() => {
									this.shootDetailsUpdated();
								}}
								projectId={this.props.params.projectID}
								isTenantCreate={false} //this.state.selectedProjectID === null}
								workspaceID={this.props.params.workspaceID}
								custClass={'modal-with-no-fixed-height'}
								displayOnly={this.state.shootEditType}
							/>
						) : null}
					</div>
				)}

				<RecordHDDContents
					show={this.state.showHddContentModal}
					handleClose={(e) =>
						this.setState({
							showHddContentModal: false,
							activeHddId: null,
						})
					}
					close={(e) =>
						this.setState({
							showHddContentModal: false,
							activeHddId: null,
						})
					}
					hardDrive={this.state.activeHddId}
					type={'add'}
				/>
				{this.state.showDuplicateCrewWithRoleWarning === false ? null : (
					<Modal
						handleClose={() =>
							this.setState({
								showDuplicateCrewWithRoleWarning: false,
								duplicateCrewWithRole: [],
								copiedCrew: [],
								isCrewCopied: false,
							})
						}
						show={this.state.showDuplicateCrewWithRoleWarning}
						modalType={'center'}
					>
						<div className="busy-modal">
							<div className="bm-header">COPY ERROR</div>
							<div className="bm-body">
								<span>
									{_.map(this.state.duplicateCrewWithRole, (dup, inx) => {
										return (
											<div>
												{`${inx + 1}. ${
													dup.name
												} (${dup.subRole[0].toUpperCase()}${
													dup.role === 'cinematographer'
														? 'V'
														: dup.role[0].toUpperCase()
												})`}
											</div>
										);
									})}
								</span>
								<p>Crew already exists with same role and sub role.</p>
							</div>
							<div className="bm-footer">
								<a
									onClick={() =>
										this.setState({
											showDuplicateCrewWithRoleWarning: false,
											duplicateCrewWithRole: [],
											copiedCrew: [],
											isCrewCopied: false,
										})
									}
								>
									Okay, Got it
								</a>
							</div>
						</div>
					</Modal>
				)}
			</>
		);
	}
}

export default withRouter(ProjectDetails);
